export default function FirmwareChangelog({ updateEntry }) {
  if (!updateEntry) return null;
  return (
    <div className="space-y-4">
      {updateEntry.changelog.map((release) => (
        <section
          key={release.version}
          className="rounded-2xl border border-brand-navy bg-brand-purple px-4 py-3 space-y-3"
        >
          <div className="flex items-center justify-between">
            <span className="text-sm font-bold text-brand-magenta">{release.version}</span>
            <span className="text-[11px] text-brand-light/50">{release.date}</span>
          </div>
          {release.highlights.length > 0 && (
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-widest text-brand-light/50 mb-1.5">
                What's New
              </p>
              <ul className="space-y-1">
                {release.highlights.map((h, i) => (
                  <li key={i} className="flex items-start gap-2 text-xs text-brand-light">
                    <span className="text-brand-magenta mt-0.5 shrink-0">•</span>
                    <span>{h}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {release.fixes.length > 0 && (
            <div>
              <p className="text-[11px] font-semibold uppercase tracking-widest text-brand-light/50 mb-1.5">
                Bug Fixes
              </p>
              <ul className="space-y-1">
                {release.fixes.map((f, i) => (
                  <li key={i} className="flex items-start gap-2 text-xs text-brand-light">
                    <span className="text-emerald-400 mt-0.5 shrink-0">✓</span>
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          )}
          {release.notes && (
            <div className="rounded-xl border border-brand-navy bg-brand-navy px-3 py-2.5">
              <p className="text-[11px] font-semibold uppercase tracking-widest text-brand-light/50 mb-1">
                Note
              </p>
              <p className="text-xs text-brand-light/70">{release.notes}</p>
            </div>
          )}
        </section>
      ))}
    </div>
  );
}
